module.exports = __webpack_public_path__ + "assets/img/step4.2364462f.png";